import React, { useState } from 'react';

import { Checkbox } from 'components/Checkbox/Checkbox';
import Dropdown from 'components/Dropdown/Dropdown';
import { Modal, Header, Body, Footer, FooterButton } from './modalElements';

export default React.memo(({ onConfirm, gdprAgreement, loading = false }) => {
  const [isAgreed, setIsAgreed] = useState(false);
  const [conditionalRetentionValue, setConditionalRetention] = useState('');
  const conditionalRetention = gdprAgreement?.conditionalRetention;

  const hideModal = () => {
    return onConfirm(conditionalRetentionValue);
  };

  const renderConditionRetention = () => {
    let options = [{ label: 'Please select country', value: '' }];
    if (conditionalRetention.options) {
      for (let option of conditionalRetention.options) {
        options.push({ label: option, value: option });
      }
    }
    if (options && options.length > 1)
      return (
        <>
          {conditionalRetention.textAbove && (
            <p
              dangerouslySetInnerHTML={{
                __html: conditionalRetention.textAbove,
              }}
            ></p>
          )}
          <Dropdown
            width="100%"
            options={options}
            value={conditionalRetentionValue || 'Please select country'}
            onChange={(value) => setConditionalRetention(value.value)}
          />
          {conditionalRetention.textBelow && (
            <>
              <p />
              <p
                dangerouslySetInnerHTML={{
                  __html: conditionalRetention.textBelow,
                }}
              ></p>
            </>
          )}
        </>
      );
  };

  return (
    <Modal isOpen={true}>
      <Header>Personal Data</Header>
      <Body loading={loading}>
        <p
          dangerouslySetInnerHTML={{
            __html: gdprAgreement?.GDPRText,
          }}
        ></p>
        {conditionalRetention && renderConditionRetention()}
        <Checkbox checked={isAgreed} label="I agree" onChange={() => setIsAgreed(!isAgreed)} />
      </Body>
      <Footer>
        <FooterButton
          disabled={
            (!conditionalRetention && !isAgreed) || (conditionalRetention && (!isAgreed || !conditionalRetentionValue))
          }
          onClick={() => hideModal(true)}
          label="Next"
        />
      </Footer>
    </Modal>
  );
});
